function dateKey(date) {
  return [
    date.getUTCFullYear(),
    String(date.getUTCMonth() + 1).padStart(2, '0'),
    String(date.getUTCDate()).padStart(2, '0'),
  ].join('-');
}

function addCalendarDays(startDate, numberOfDays) {
  const result = new Date(startDate);
  result.setUTCDate(result.getUTCDate() + Math.max(0, Math.trunc(numberOfDays)));
  return result;
}

function stockholmToday() {
  const parts = new Intl.DateTimeFormat('sv-SE', {
    timeZone: 'Europe/Stockholm',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  }).formatToParts(new Date());
  const values = Object.fromEntries(parts.map(({ type, value }) => [type, value]));

  return new Date(Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day), 12));
}

function formatDeliveryRange(startDate, endDate) {
  const dayFormatter = new Intl.DateTimeFormat('sv-SE', { day: 'numeric', timeZone: 'UTC' });
  const dateFormatter = new Intl.DateTimeFormat('sv-SE', {
    day: 'numeric',
    month: 'long',
    timeZone: 'UTC',
  });

  if (dateKey(startDate) === dateKey(endDate)) return dateFormatter.format(startDate);

  if (
    startDate.getUTCFullYear() === endDate.getUTCFullYear() &&
    startDate.getUTCMonth() === endDate.getUTCMonth()
  ) {
    return `${dayFormatter.format(startDate)}–${dateFormatter.format(endDate)}`;
  }

  return `${dateFormatter.format(startDate)}–${dateFormatter.format(endDate)}`;
}

class ZooCareDeliveryEstimate extends HTMLElement {
  connectedCallback() {
    const minDays = Number.parseInt(this.dataset.minDays, 10);
    const maxDays = Number.parseInt(this.dataset.maxDays, 10);

    if (!Number.isFinite(minDays) || !Number.isFinite(maxDays) || minDays < 0 || maxDays < 0) return;

    const firstDays = Math.min(minDays, maxDays);
    const lastDays = Math.max(minDays, maxDays);
    const today = stockholmToday();
    const firstDate = addCalendarDays(today, firstDays);
    const lastDate = addCalendarDays(today, lastDays);
    const accessibilityLabel =
      dateKey(firstDate) === dateKey(lastDate)
        ? `den ${dateFormatterForAccessibility.format(firstDate)}`
        : `mellan ${dateFormatterForAccessibility.format(firstDate)} och ${dateFormatterForAccessibility.format(lastDate)}`;

    this.textContent = formatDeliveryRange(firstDate, lastDate);
    this.setAttribute('aria-label', accessibilityLabel);
  }
}

const dateFormatterForAccessibility = new Intl.DateTimeFormat('sv-SE', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
  timeZone: 'UTC',
});

if (!customElements.get('zoocare-delivery-estimate')) {
  customElements.define('zoocare-delivery-estimate', ZooCareDeliveryEstimate);
}
